import { useCallback, useEffect } from "react"
import isOnline from 'is-online';
import { useDispatch } from "react-redux";
import {setOnline} from '../../store/cache.slice'

export const useConnectivityHandler = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		isOnline().then(online => online ? onOnline() : onOffline());

		window.addEventListener('offline', onOffline);
		window.addEventListener('online', onOnline);

		return () => {
			window.removeEventListener('offline', onOffline);
			window.removeEventListener('online', onOnline);
		}
	}, []);

	const onOnline = useCallback(() => dispatch(setOnline(true)), []);
	const onOffline = useCallback(() => dispatch(setOnline(false)), []);

	
}